import { z } from "zod"

export const LastContextSchema = z
  .union([
    z.object({
      name: z.string().default(""),
      description: z.string().default(""),
    }),
    z.array(z.string()),
  ])
  .transform((context) =>
    Array.isArray(context)
      ? context
      : [
          context.name ? `Name: ${context.name}` : "",
          context.description ? `Description: ${context.description}` : "",
        ].filter(Boolean),
  )
  .nullable()

export type LastContext = z.infer<typeof LastContextSchema>

export const GetWidgetConfigurationSchema = z.object({
  slug: z.string(),
})

export const StartWidgetConversationBodySchema = z.object({
  slug: z.string(),
  origin: z.string().optional(),
  baseUrl: z.string().optional(),
  storageDiagnostics: z
    .object({
      status: z.enum(["available", "blocked", "invalid"]),
      hasConversationSlug: z.boolean(),
    })
    .optional(),
  widgetMode: z.enum(["default", "fullscreen", "iframe"]).optional(),
  queryParams: z.record(z.string(), z.string()).optional(),
  referrer: z.string().optional(),
  acquisitionChannel: z
    .enum(["Paid", "Organic", "Referral", "Direct", "Email", "Social"])
    .optional(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  name: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  locale: z.string().nullish(),
  country: z.string().nullish(),
  metadata: z.record(z.string(), z.unknown()).nullish(),
  lastContext: LastContextSchema.optional(),
})

export const IdentifyUserBodySchema = z.object({
  email: z.string().nullish(),
  phone: z.string().nullish(),
  name: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  locale: z.string().nullish(),
  country: z.string().nullish(),
  conversationSlug: z.string(),
  metadata: z.record(z.string(), z.unknown()).nullish(),
})
